import React from "react"
import "./header.scss"
import loadable from '@loadable/component'

import { secondaryPagesHeaderImages } from "../../utils/informations"


const SecondaryPagesHeader = loadable(() => import("../secondary-pages-header/secondary-pages-header"))
const Form = loadable(() => import("../form/form.js"))




const Header = ({ props, origin, price }) => {
    let priceBackground = secondaryPagesHeaderImages.filter((item) => item.origin === origin)

    return (
        props.filter((item) => item.origin === origin).map((obj, index) => {

            const { title, description, image, imgwebp, imgpng, checks } = obj

            return (
                <>
                    <SecondaryPagesHeader key={index} origin={origin} title={title} description={description} image={image} price={price} priceBackground={priceBackground[0]} imgwebp={imgwebp} imgpng={imgpng} checks={checks} />
                    <Form />
                </>

            )
        })
    )
}


export default Header